import dicomParser from 'dicom-parser';

export type PixelSpacingSource = 'dicom' | 'manual' | 'missing';

export interface ExtractedPixelSpacing {
  value: number | null;
  source: PixelSpacingSource;
}

function parseSpacingValue(raw: string | undefined): number | null {
  if (!raw) return null;
  const parts = raw.split('\\').map((p) => parseFloat(p.trim()));
  const first = parts.find((n) => Number.isFinite(n) && n > 0);
  return first ?? null;
}

/**
 * Read Pixel Spacing (0028,0030) from a DICOM file buffer.
 */
export async function extractPixelSpacingFromDicomFile(
  file: File
): Promise<ExtractedPixelSpacing> {
  try {
    const buffer = await file.arrayBuffer();
    const byteArray = new Uint8Array(buffer);
    const dataSet = dicomParser.parseDicom(byteArray);
    const raw = dataSet.string('x00280030');
    const value = parseSpacingValue(raw);
    if (value != null) {
      return { value, source: 'dicom' };
    }
    return { value: null, source: 'missing' };
  } catch {
    return { value: null, source: 'missing' };
  }
}
